module.exports = __webpack_public_path__ + "img/close2.ff66f371.png";